import { render, staticRenderFns } from "./home-content-ad.vue?vue&type=template&id=536e7257&scoped=true"
import script from "./home-content-ad.vue?vue&type=script&lang=js"
export * from "./home-content-ad.vue?vue&type=script&lang=js"
import style0 from "./home-content-ad.vue?vue&type=style&index=0&id=536e7257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e7257",
  null
  
)

export default component.exports